import { css } from "@emotion/css";

import { _Tag } from "./assets/_Tag";
import { TaggableValue, TagGroupProps } from "./types";

export function TagGroup<V extends TaggableValue>(props: TagGroupProps<V>) {
  const {
    label,
    description,
    errorMessage,
    handleRemove,
    testID,
    isDisabled,
    values,
  } = props;

  const handleValueRemove = (valueId: string | number) => {
    if (!isDisabled) {
      handleRemove(new Set([valueId]));
    }
  };

  return (
    <div
      aria-label={label || "Tag group"}
      data-testid={testID}
      className={styles.valueGroup}
    >
      {label && <div className={styles.label}>{label}</div>}
      {description && <div className={styles.description}>{description}</div>}
      <div className={styles.valueList}>
        {values.map((value) => (
          <div key={value.id}>
            <_Tag
              isDisabled={isDisabled}
              id={String(value.id)}
              textValue={value.tagValue}
              onRemove={() => handleValueRemove(value.id)}
            />
          </div>
        ))}
      </div>
      {errorMessage && <div className={styles.error}>{errorMessage}</div>}
    </div>
  );
}

const styles = {
  valueList: css({
    display: "flex",
    gap: "var(--space-2)",
    flexWrap: "wrap",
    padding: "0px",
  }),
  valueGroup: css({
    padding: "0px !important",
  }),
  label: css({
    marginBottom: "var(--space-2)",
    fontWeight: "500",
  }),
  description: css({
    marginBottom: "var(--space-2)",
    color: "var(--text-secondary)",
  }),
  error: css({
    marginTop: "var(--space-2)",
    color: "var(--error)",
  }),
};
